import { URL } from "../../api/Api";
import { NOTIFICATION } from "../Action";
import { catchError, GET, PATCH } from "../axios/Axios";

export const ProcessNotification = async () => {
  try {
    const response = await GET(`${URL}/process-notifications/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const DeadlineNotification = async () => {
  try {
    const response = await GET(`${URL}/deadline-notification/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const UnreadNotification = async () => {
  try {
    const response = await GET(`${URL}/unread-notifications/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const NotificationRemove = async (payload) => {
  try {
    const response = await PATCH(
      `${URL}/mark-notifications-read/`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const NotificationCount = ({ data }) => {
  return {
    type: NOTIFICATION.count,
    data: data,
  };
};
